import { P2GBox } from '@parcel2go/core-ui';
import { P2GLink } from '@parcel2go/core-ui';
import { P2GText } from '@parcel2go/core-ui';
import { useState } from 'react';
import { ProviderGroup } from '../../../../lib/helpers/SmartSendBulkActionApplier';
import { AsyncLinks } from './AsyncLinks';
import { Tagged } from '../../../Tagged';
import { P2GSidePanel } from '~/components/sidepanel';
import { TranslationNamespaces } from '~/lib/constants';
import { Trans, useTranslation } from 'react-i18next';

interface props {
  providers: ProviderGroup[];
}

export default function LabelSummary(props: props) {
  const [showSummary, setShowSummary] = useState(false);
  const list = props.providers.filter((x) => x.ShipResponse?.BookingStatus === 'Booked');
  const { t } = useTranslation(TranslationNamespaces.SMARTSEND);

  if (list.length === 0) {
    return null;
  }

  return (
    <>
      <P2GText variant="body2" component="p" onClick={(e) => e.stopPropagation()}>
        <Trans
          t={t}
          i18nKey="LABEL_DOWNLOAD_SUMMARY_INFO"
          components={{ a: <P2GLink onClick={() => setShowSummary(!showSummary)} /> }}
          defaults="You can see a quick summary of your label downloads <a>here</a>."
        />
      </P2GText>
      <P2GSidePanel
        open={showSummary}
        anchor="right"
        title={t('LABEL_SUMMARY_SIDEPANEL_TITLE', { defaultValue: 'Label Summary' })}
        onClose={() => setShowSummary(false)}
      >
        <Tagged tag="panel-label-summary">
          {list.map((g, i) => (
            <P2GBox mt={i > 0 ? 2 : 0} key={g.Key}>
              <AsyncLinks
                variant="label"
                tag={`Order ${g.ShipResponse.Reference}`}
                links={g.ShipResponse?.Links}
                title={null}
                match={(x) => x.Type.startsWith('ORDER-LABELS-')}
              >
                <P2GText component="p" colour="primary">
                  <strong>
                    <Trans
                      t={t}
                      i18nKey="LABEL_DOWNLOAD_SUMMARY_LINK"
                      values={{ reference: g.ShipResponse.Reference }}
                      defaults="Download Your Labels ({{reference}})"
                    />
                  </strong>
                </P2GText>
              </AsyncLinks>
            </P2GBox>
          ))}
        </Tagged>
      </P2GSidePanel>
    </>
  );
}
